import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MDButton from "../../components/MDButton";
import { CORPORATE_ADMIN } from "../../utils/Roles/Roles";

function PageNotFound() {
  const navigate = useNavigate();
  const storeData = useSelector((state) => state.loginUser.loginUserState);
  const userType = storeData.type;
  return (
    <div style={{ marginTop: "100px", textAlign: "center" }}>
      <h1>404</h1>
      <div>
        <h2>The page you requested was not found.</h2>
        <MDButton
          style={{ marginTop: "10px" }}
          variant="gradient"
          color="newColor"
          onClick={() =>
            navigate(CORPORATE_ADMIN === userType ? "/registrations" : "/home", { replace: true })
          }
        >
          go to home
        </MDButton>
      </div>
    </div>
  );
}

export default PageNotFound;
